import Modal from "@components/Modal";
import Services from "@components/ProductPage/ProductServices/Services";

const ProductServicesModal = ({ services, activeServices, serviceClick }) => (
  <Modal
    id="productServicesModal"
    header="Adauga extra servicii"
    position="right"
  >
    <Services
      services={services}
      activeServices={activeServices}
      onServiceSelect={serviceClick}
    />
  </Modal>
);
export default ProductServicesModal;
